module.exports = __webpack_public_path__ + "static/img/indexbg10.cad0487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg10.jpg
// module id = WOQp
// module chunks = 1